export default function (elementBounds, viewportBounds, offset) {
  var offsetTop = offset && offset.top || 0;
  var offsetRight = offset && offset.right || 0;
  var offsetBottom = offset && offset.bottom || 0;
  var offsetLeft = offset && offset.left || 0;
  return elementBounds.bottom + offsetBottom >= viewportBounds.top && elementBounds.top - offsetTop <= viewportBounds.bottom && elementBounds.right + offsetRight >= viewportBounds.left && elementBounds.left - offsetLeft <= viewportBounds.right;
}